module.exports = __webpack_public_path__ + "static/img/b8f50a6b.c10.ce2f415.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/rowdy-coyote/b8f50a6b.c10.jpg
// module id = nVFQ
// module chunks = 2